import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as SVG2 } from '../../assets/Orbs.svg';
import { ReactComponent as SVG1 } from '../../assets/Orbs1.svg';
import Footer from '../Footer/Footer.jsx';
import artwork from '../../assets/artwork.svg';

const Home = () => {
    return (
        <div className="landing-page">
            <div
                style={{
                    position: 'relative', height: 700, padding: '10%', margin: 0, width: '100%',
                    overflow: 'hidden' }}
                          >
                <SVG1 style={{ width: '100%' }} className="position-absolute top-50 start-50 translate-middle mw-100" />
                <SVG2 style={{ height: '40rem', width: '100%' }} className="position-absolute top-40 start-50 translate-middle" />
            
                <p style={{ fontFamily: 'Belarin, sans-serif', position: 'absolute', top: '10%', left: '50%', transform: "translateX(-50%)", fontSize: '5.6rem'}}>
                    FairSplit
                </p>

                <p style={{ fontFamily: 'Montserrat, sans-serif', position: 'absolute', top: '30%', left: '50%', transform: "translateX(-50%)", fontSize: '1.6rem', fontWeight: 400 }} className="text-center">
                Split Bills, Not Friendships
                </p>

                <p style={{
                    fontFamily: 'Montserrat, sans-serif', position: 'absolute', top: '50%', left: '50%', transform: "translateX(-50%)", width: '90%', fontSize: '1.4rem', fontWeight: 600
                }} className="text-center">
                    FairSplit makes it easy to split costs regardless of occasion.
                </p>

                <p style={{ fontFamily: 'Montserrat, sans-serif', position: 'absolute', top: '60%', left: '50%', transform: "translateX(-50%)", width: '90%', fontSize: '1.3rem', fontWeight: 400 }}
                    className="text-center">
                    Enjoy great dinners, create wonderful memories with people you care about, without letting economy get in the way.
                </p>
            

            <div className="d-flex justify-content-center gap-5"
                    style={{
                        marginBottom: "5rem", position: 'absolute',
                        top: '75%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 10,
                        width: '100%',
                }}>
                <Link
                    to="/login"
                    className="btn rounded-pill px-5 py-2 login-button"
                    role="button"
                >
                    Login
                </Link>
                    <Link
                        to="/registerform"
                        className="btn rounded-pill px-5 py-2  register-btn"
                        role="button"
                    >
                        Register Now
                    </Link>

                </div>
            </div>

            <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                <img
                    src={artwork}
                    alt="Artwork"
                    className="img-fluid"
                    style={{ maxWidth: "90vw", margin: "2rem 0" }}
                />
            </div>
            
            <Footer />
    </div>
  );
};

export default Home;